import { reverse } from "lodash";
import inView from "in-view";

const PopoutUtilities = {
  getPopouts() {
    const popoutCollection = document.getElementsByClassName("popout");
    const popouts = [];
    for (var i = 0; i < popoutCollection.length; i++) {
      popouts.push(popoutCollection[i]);
    }
    return popouts;
  },
  getBodyHeight() {
    const body = document.getElementsByClassName("content-page__body")[0];
    const bodyRect = body.getBoundingClientRect();
    const bodyHeight = bodyRect.height;
    return bodyHeight;
  },
  getPopoutVerticalSpace(popout) {
    const popoutRectangle = popout.getBoundingClientRect();
    const popoutVerticalSpace = popoutRectangle.y + popoutRectangle.height;
    return popoutVerticalSpace;
  },
  getBottomOverflow(popout) {
    const bodyHeight = PopoutUtilities.getBodyHeight();
    const popoutVerticalSpace = PopoutUtilities.getPopoutVerticalSpace(popout);
    return popoutVerticalSpace - bodyHeight;
  },
  checkForBottomOverflow(popout) {
    const overflow = PopoutUtilities.getBottomOverflow(popout);
    if (overflow > 0) {
      PopoutUtilities.repositionPopout(popout, overflow);
    }
  },
  repositionPopout(popout, overflow) {
    if (overflow > 0) {
      const displacement = overflow * -1;
      popout.style.top = `${displacement}px`;
    }
  },
  checkPopoutsForOverflow() {
    const popouts = PopoutUtilities.getPopouts();
    popouts.forEach((popout) => {
      PopoutUtilities.checkForBottomOverflow(popout);
    });
  },
  getPopoutOverlap(popout, lastTopBorder) {
    const popoutVerticalSpace = PopoutUtilities.getPopoutVerticalSpace(popout);
    return popoutVerticalSpace - lastTopBorder;
  },
  checkPopoutsForOverlap() {
    const popouts = PopoutUtilities.getPopouts();
    reverse(popouts);
    let lastTopBorder = 0;
    popouts.forEach((popout, index) => {
      if (index > 0) {
        const overlap = PopoutUtilities.getPopoutOverlap(popout, lastTopBorder);
        if (overlap > 0) {
          PopoutUtilities.repositionPopout(popout, overlap);
        }
      }
      lastTopBorder = popout.getBoundingClientRect().y;
    });
  },
  attachPopoutListener() {
    inView(".popout").on("enter", (el) => {
      el.classList.add("popout--inview");
    });
  },
};

export default PopoutUtilities;
